import { css, SwipeableDrawer as MuiSwipeableDrawer, styled } from '@mui/material'
import { Z_INDEX_SWIPEABLE_DRAWER } from 'redesign/shared/zIndex/constants'

export const SwipeableDrawer = styled(MuiSwipeableDrawer, {
  shouldForwardProp: (prop) => prop !== 'fullHeight' && prop !== 'heightSpacing' && prop !== 'customZIndex',
})<{ fullHeight: boolean; heightSpacing?: number; customZIndex?: number }>`
  & .MuiPaper-root {
    border-top-right-radius: ${({ theme }) => theme.spacing(3)};
    border-top-left-radius: ${({ theme }) => theme.spacing(3)};
    z-index: ${Z_INDEX_SWIPEABLE_DRAWER};
    ${({ fullHeight }) =>
      fullHeight &&
      // Need to do calc with bottom safe space since we have a padding bottom that would overflow the top bar
      css`
        height: calc(100% - var(--ion-safe-area-top) - var(--ion-safe-area-bottom));
      `};
    ${({ theme, heightSpacing }) =>
      heightSpacing &&
      css`
        height: calc(${theme.spacing(heightSpacing)} - var(--ion-safe-area-top));
      `};
    max-width: ${({ theme }) => theme.spacing(75)};
    margin: 0 auto;
    display: grid;
    grid-template-rows: auto 1fr auto;
    padding-bottom: var(--ion-safe-area-bottom);
  }

  ${({ customZIndex }) =>
    customZIndex &&
    css`
      z-index: ${customZIndex} !important;
    `}
`

export const ContentContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'backgroundColor',
})<{ backgroundColor?: string }>`
  height: 100%;
  flex: 1;
  overflow: hidden;
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor ? backgroundColor : theme.palette.background.base};
`

export const FooterContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  padding: ${({ theme }) => theme.spacing(2)};
`
